// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const generalSearchResource = '/merchant/general-search/'

export default {
  cityListByName(searchTerm) {
    return OperationRepository.get(`${generalSearchResource}city-list-by-name?search_term=${searchTerm}`)
  },
}
